// extracted by mini-css-extract-plugin
export default {"videoBoxSnackbarContainer":"_videoBoxSnackbarContainer--I3w9A","Alert":"_Alert--JBEJU","Success":"_Success--EWncB"};